import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { AppState } from "../store/state/app.state";

@Injectable({
  providedIn: "root",
})
export class ReportingRouteGuardService implements CanActivate {
  constructor(
    private router: Router,
    private http: HttpClient,
    private store: Store<AppState>,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    if (route.routeConfig.path === "broker/:brokerName") {
      const ticker = route.params.brokerName;
      this.http
        .get(`${window.apiUrl}/api/get_broker_new_short_name?broker=${ticker}`)
        .subscribe((res: any) => {
          if (Object.entries(res).length && !!Object.values(res)[0]) {
            const pathName = location.pathname.split("/");
            location.href = `https://${location.hostname}${pathName
              .slice(0, pathName.length - 1)
              .join("/")}/${Object.values(res)[0]}`;
          }
        });
    }

    return true;
  }
}
